module.exports = __webpack_public_path__ + "static/media/coliseu_porto_ageas_circo_2023_11.f6b76783.webp";